(function () {
  'use strict';

  var readyMarker = 'data-camo-cast-fixes-ready';
  var documentElement = document.documentElement;

  if (!documentElement || documentElement.hasAttribute(readyMarker)) return;
  documentElement.setAttribute(readyMarker, '');

  var logoChoiceName = 'Do you already have a logo?';
  var logoChoiceValue = 'I have a logo';
  var informationName = 'Your information';
  var errorIdSequence = 0;
  var normalizeQueued = false;

  function productScope(element) {
    return element.closest('.shopify-section') || element.closest('product-info') || document;
  }

  function selectedLogoChoice(scope) {
    var property = scope.querySelector(
      '[name="properties[' + logoChoiceName + ']"]:checked,' +
        '[name="properties[' + logoChoiceName + ']"]:not([type="radio"]):not([type="checkbox"])'
    );
    var field = scope.querySelector(
      'custom-product-field[data-name="' + logoChoiceName + '"]'
    );
    var selected = field && field.querySelector('input[type="radio"]:checked');

    if (property) return property.value;
    if (selected) return selected.value;

    selected = scope.querySelector(
      'input[type="radio"][name="properties[' + logoChoiceName + ']"]:checked,' +
        'input[type="radio"][name="' + logoChoiceName + '"]:checked'
    );

    return selected ? selected.value : '';
  }

  function findLogoUpload(scope) {
    return scope.querySelector('#CamoLogoUpload') || document.getElementById('CamoLogoUpload');
  }

  function findInformationFields(scope) {
    var property = scope.querySelector('[name="properties[' + informationName + ']"]');
    var customField = scope.querySelector(
      'custom-product-field[data-name="' + informationName + '"]'
    );
    var visibleControl = customField && customField.querySelector('textarea, input:not([type="hidden"])');
    var plainField = scope.querySelector('[name="' + informationName + '"]');

    return {
      valueField: property || visibleControl || plainField,
      visibleControl: visibleControl || property || plainField
    };
  }

  function isVisibleControl(element) {
    var current;

    if (!element || element.disabled || element.type === 'hidden') return false;

    current = element;
    while (current && current.nodeType === 1) {
      if (current.hidden || current.getAttribute('aria-hidden') === 'true') return false;
      if (window.getComputedStyle) {
        var style = window.getComputedStyle(current);
        if (style.display === 'none' || style.visibility === 'hidden') return false;
      }
      current = current.parentElement;
    }

    return true;
  }

  function visibleControlFor(field, scope, fieldName) {
    if (isVisibleControl(field)) return field;

    var customField = scope.querySelector(
      'custom-product-field[data-name="' + fieldName + '"]'
    );
    if (!customField) return null;

    var controls = customField.querySelectorAll('textarea, input:not([type="hidden"])');
    for (var index = 0; index < controls.length; index += 1) {
      if (isVisibleControl(controls[index])) return controls[index];
    }

    return null;
  }

  function nextErrorId() {
    var id;

    do {
      errorIdSequence += 1;
      id = 'camo-cast-bundle-error-' + errorIdSequence;
    } while (document.getElementById(id));

    return id;
  }

  function guardError(scope, addButton) {
    var error = scope.querySelector('.cb-guard-error');

    if (!error) {
      error = document.createElement('div');
      error.className = 'cb-err cb-guard-error camo-cast-validation-error';
      error.id = nextErrorId();
      error.setAttribute('role', 'alert');
      error.setAttribute('aria-live', 'assertive');
      error.setAttribute('aria-atomic', 'true');
      error.tabIndex = -1;
    }

    if (addButton && addButton.parentNode) {
      addButton.parentNode.insertBefore(error, addButton.nextSibling);
    }

    return error;
  }

  function addDescription(element, id) {
    var values = (element.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (values.indexOf(id) === -1) values.push(id);
    element.setAttribute('aria-describedby', values.join(' '));
  }

  function markInvalid(element, error) {
    if (!element) return;

    if (!element.hasAttribute('data-cc-guard-invalid')) {
      element.setAttribute(
        'data-cc-guard-had-invalid',
        element.hasAttribute('aria-invalid') ? 'true' : 'false'
      );
      element.setAttribute(
        'data-cc-guard-invalid',
        element.hasAttribute('aria-invalid') ? element.getAttribute('aria-invalid') : ''
      );
    }

    element.setAttribute('aria-invalid', 'true');
    element.setAttribute('data-cc-guard-error-id', error.id);
    addDescription(element, error.id);
  }

  function restoreInvalidState(element, errorIds) {
    var previous = element.getAttribute('data-cc-guard-invalid');
    var hadInvalid = element.getAttribute('data-cc-guard-had-invalid') === 'true';
    var ownErrorId = element.getAttribute('data-cc-guard-error-id');
    var idsToRemove = errorIds.slice();
    if (ownErrorId && idsToRemove.indexOf(ownErrorId) === -1) idsToRemove.push(ownErrorId);
    var descriptions = (element.getAttribute('aria-describedby') || '')
      .split(/\s+/)
      .filter(function (value) {
        return value && idsToRemove.indexOf(value) === -1;
      });

    if (hadInvalid) element.setAttribute('aria-invalid', previous);
    else element.removeAttribute('aria-invalid');

    if (descriptions.length) element.setAttribute('aria-describedby', descriptions.join(' '));
    else element.removeAttribute('aria-describedby');

    element.removeAttribute('data-cc-guard-invalid');
    element.removeAttribute('data-cc-guard-had-invalid');
    element.removeAttribute('data-cc-guard-error-id');
  }

  function clearGuardState(scope) {
    var errors = scope.querySelectorAll('.cb-guard-error');
    var errorIds = [];
    var invalidFields = scope.querySelectorAll('[data-cc-guard-invalid]');

    for (var errorIndex = 0; errorIndex < errors.length; errorIndex += 1) {
      var error = errors[errorIndex];
      errorIds.push(error.id);
      error.textContent = '';
      error.hidden = true;
    }

    for (var fieldIndex = 0; fieldIndex < invalidFields.length; fieldIndex += 1) {
      restoreInvalidState(invalidFields[fieldIndex], errorIds);
    }
  }

  function focusAndScroll(element, fallback) {
    var target = element || fallback;
    if (!target) return;

    if (typeof target.scrollIntoView === 'function') {
      try {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        target.scrollIntoView();
      }
    }

    if (typeof target.focus === 'function') {
      try {
        target.focus({ preventScroll: true });
      } catch (error) {
        target.focus();
      }
    }
  }

  function showGuardError(scope, addButton, field, message, fieldName) {
    var error = guardError(scope, addButton);
    var visibleField = visibleControlFor(field, scope, fieldName);

    error.hidden = false;
    error.textContent = message;
    markInvalid(visibleField, error);
    focusAndScroll(visibleField, error);
  }

  function interceptBundlePurchase(event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('.cb-add, .cb-buy') : null;
    var scope;
    var addButton;
    var logoUpload;
    var information;

    if (!button) return;

    scope = productScope(button);
    if (!scope.querySelector('[data-cb]')) return;

    if (selectedLogoChoice(scope) !== logoChoiceValue) {
      clearGuardState(scope);
      return;
    }

    addButton = scope.querySelector('.cb-add') || button;
    logoUpload = findLogoUpload(scope);

    if (!logoUpload || !logoUpload.files || logoUpload.files.length === 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showGuardError(
        scope,
        addButton,
        logoUpload,
        'Upload your logo before adding this bundle to your cart.',
        'Upload your logo'
      );
      return;
    }

    information = findInformationFields(scope);
    if (!information.valueField || !String(information.valueField.value || '').trim()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showGuardError(
        scope,
        addButton,
        information.visibleControl,
        'Enter your information before adding this bundle to your cart.',
        informationName
      );
      return;
    }

    clearGuardState(scope);
  }

  function isGuardControl(element) {
    var field;
    var name;

    if (!element || element.nodeType !== 1) return false;
    if (element.id === 'CamoLogoUpload') return true;

    name = element.getAttribute('name') || '';
    if (
      name === logoChoiceName ||
      name === informationName ||
      name === 'properties[' + logoChoiceName + ']' ||
      name === 'properties[' + informationName + ']'
    ) {
      return true;
    }

    field = element.closest('custom-product-field[data-name]');
    return Boolean(
      field && (field.getAttribute('data-name') === logoChoiceName || field.getAttribute('data-name') === informationName)
    );
  }

  function clearEditedGuard(event) {
    if (!isGuardControl(event.target)) return;
    clearGuardState(productScope(event.target));
  }

  function optionNames(bundle) {
    try {
      var options = JSON.parse(bundle.getAttribute('data-options') || '[]');
      if (!Array.isArray(options)) return [];
      return options.map(function (option) {
        return option && option.name ? String(option.name) : '';
      });
    } catch (error) {
      return [];
    }
  }

  function normalizeBundle(bundle) {
    var names = optionNames(bundle);
    var rows = bundle.querySelectorAll('.cb-item');
    var customTier = bundle.querySelector('[data-custom]');

    for (var rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
      var selects = rows[rowIndex].querySelectorAll('select.cb-sel');

      for (var selectIndex = 0; selectIndex < selects.length; selectIndex += 1) {
        var optionName = names[selectIndex] || 'Option ' + (selectIndex + 1);
        var selectLabel = 'Crew member ' + (rowIndex + 1) + ': ' + optionName;
        if (selects[selectIndex].getAttribute('aria-label') !== selectLabel) {
          selects[selectIndex].setAttribute('aria-label', selectLabel);
        }
      }
    }

    if (!customTier) return;

    var nameElement = customTier.querySelector('.cb-name');
    var groupLabel = (nameElement && nameElement.textContent.trim()) || 'Custom quantity';

    if (customTier.getAttribute('role') !== 'group') customTier.setAttribute('role', 'group');
    if (customTier.getAttribute('aria-label') !== groupLabel) {
      customTier.setAttribute('aria-label', groupLabel);
    }
    if (customTier.hasAttribute('tabindex')) customTier.removeAttribute('tabindex');
    if (customTier.hasAttribute('aria-checked')) customTier.removeAttribute('aria-checked');
  }

  function normalizePage() {
    normalizeQueued = false;
    var bundles = document.querySelectorAll('.cb-wrap[data-options]');
    for (var index = 0; index < bundles.length; index += 1) normalizeBundle(bundles[index]);
  }

  function queueNormalize() {
    if (normalizeQueued) return;
    normalizeQueued = true;
    window.setTimeout(normalizePage, 0);
  }

  function startNormalizer() {
    normalizePage();

    if (!window.MutationObserver || !document.body) return;

    var observer = new MutationObserver(queueNormalize);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role', 'tabindex', 'aria-checked']
    });
  }

  document.addEventListener('click', interceptBundlePurchase, true);
  document.addEventListener('change', clearEditedGuard, true);
  document.addEventListener('input', clearEditedGuard, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startNormalizer, { once: true });
  } else {
    startNormalizer();
  }
})();
